import { Panel, Button, Input } from "@swivl-mono/ui";
import AccountModel from "../../../../Models/Account/AccountModel";
import { useState } from "react";

export function UpdatePasswordComponent() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const updatePassword = () => {
    if (newPassword !== confirmPassword) {
      // show error
      alert('Passwords do not match')
      return
    }
    setLoading(true)

    AccountModel.updatePassword(currentPassword, newPassword).then(() => {
      alert('Password updated')
    }).catch((e) => {
      alert('Failed to update password')
    }).finally(() => {
      // call api to update password
      setLoading(false)
    });
  }
  return (
    <Panel className="my-5 w-1/3" header="Update Password">
      <div className="flex flex-col">
        <div className="flex flex-col">
          <label className="text-sm font-semibold">Current Password</label>
          <Input type={Input.Type.Password} className="input" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
        </div>
        <div className="flex flex-col mt-5">
          <label className="text-sm font-semibold">New Password</label>
          <Input type={Input.Type.Password} className="input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
        </div>
        <div className="flex flex-col my-5">
          <label className="text-sm font-semibold">Confirm New Password</label>
          <Input type={Input.Type.Password} className="input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </div>
        <Button onClick={updatePassword} loading={loading}>Update Password</Button>
      </div>
    </Panel>
  )
}
